import React from 'react'
import { useSelector } from 'react-redux'
import { constants } from '../../../Constants/constants'
import { getString } from '../../../helper/util'
import { TempBtn } from '../../Input/TempBtn'

/**
 * Bottom Bar copy from EditCreateDisplay
 * @param {Array} bottomBtns config item array
 */
export default function BottomBarFromEditCreateDisplay({ bottomBtns }) {

    const lang = useSelector((state) => state.lang.ui.lang)
    const theme = useSelector((state) => state.theme.ui.theme)

    return (
        <div className="edit-footer-wrapper padding-16" style={{width: '100%'}}>
            {
                bottomBtns && (
                    bottomBtns.map((btnSetting, btnIndex) => {
                        let content = <></>
                        if (btnSetting.type === constants.TYPE.TEXT) {
                            content = (
                                <div key={'btn_' + btnIndex} className={btnSetting.className}>
                                    {getString(
                                        lang,
                                        btnSetting.label.resource ? btnSetting.label.resource : '',
                                        btnSetting.label.key ? btnSetting.label.key : '',
                                        theme
                                    ) + btnSetting.value}
                                </div>
                            )
                        } else {
                            content = <TempBtn key={'btn_' + btnIndex} btnSetting={btnSetting} />
                        }
                        return content
                    })
                )
            }
        </div>
    )
}
